import type { Ref, DeepReadonly } from 'vue'

export interface UseThreeDSceneLoading {
  isSceneLoading: DeepReadonly<Ref<boolean>>
}

export default function useThreeDSceneLoading({
  progress,
  onSceneLoaded = () => {},
}: {
  progress: Ref<number>
  onSceneLoaded?: () => void
}): UseThreeDSceneLoading {
  const isSceneLoading = ref(true)

  watch(
    progress,
    progress => {
      if (progress === 1) {
        setTimeout(() => {
          isSceneLoading.value = false
          onSceneLoaded()
        }, 1000)
      }
    },
    { immediate: true }
  )

  return {
    isSceneLoading: readonly(isSceneLoading),
  }
}
